import {CALCULATE, RETRIEVE_RECOMMENDATIONS_FULFILLED} from "../actions";
import {bookPrices, resultMappings} from "../data";

const roundToZero = (i) => Math.max(0, i);

const initialState = {
  savings: 0,
  copy: {...resultMappings[0]},
  recommendations: [{}, {}, {}],
  allRecommendations: {}
};

export default function reducer(state=initialState, action) {
  switch(action.type) {
    case CALCULATE:
      const {
        affordabilityCalculatorStudsperyear: students,
        affordabilityCalculatorCurrenttextbookcost: cost,
        affordabilityCalculatorSubject: subject } = action.payload;
      const thBookPrice = bookPrices[subject] || 0;
      const _savings = (students * cost) - (students * thBookPrice);
      const savings = roundToZero(Math.round(_savings));
      const copy = resultMappings.filter((data) => data.min <= savings && data.max >= savings)[0];
      const recommendations = state.allRecommendations[subject] || [];
      return {...state, savings, copy, recommendations};
    case RETRIEVE_RECOMMENDATIONS_FULFILLED:
      return {...state, allRecommendations: action.payload.data};
    default:
      return {...state}
  }
}


// WEBPACK FOOTER //
// ./src/reducers/results.js